import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { beskarContext } from "./utils";
export function BeskarProvider(_param) {
    var children = _param.children, rest = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(beskarContext.Provider, {
        value: rest,
        children: children
    });
}
